var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 9.4v1.1c0 2.2-1.8 4-4 4h-4c-2.2 0-4-1.8-4-4v-4c0-2.2 1.8-4 4-4h1c.5 0 1 .4 1 .9v.1c0 .5-.4 1-.9 1h-1.1c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-1c0-.5.4-1 .9-1h.1c.5 0 1 .4 1 .9Zm1.1-8.9h-5.1c-.5 0-1 .4-1 .9v.1c0 .5.4 1 .9 1H11.034l-5.8 5.7c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l5.7-5.6v2.5c0 .6.4 1 1 1s1-.4 1-1v-5c0-.5-.4-1-.9-1Z",
    fill: "#51BB7B"
  })));
};
export default SvgExternalLink;